import { ITheme } from "../store/slices/theme";

interface IPalette {
  primary?: string;
  secondary?: string;
  tertiary?: string;
  Primary?: string;
  Secondary?: string;
  Tertiary?: string;
}

export interface ILegalDocuments {
  [key: string]: IDocuments;
}

interface IDocuments {
  faq?: string;
  termsAndConditions?: string;
  privacyPolicy?: string;
  cookiePolicy?: string;
}

export interface IPagesConfig {
  bottomNavbar?: string[];
  directory?: string[];
  profile?: string[];
  settings: ISettingConfig;
}

export interface ISettingConfig {
  [categoryName: string]: string[];
}
export interface ILanguage {
  items: string[];
  default: string;
}

export enum IThemeEnum {
  legacy = 'legacy',
  vertical = 'vertical'
}

export interface IWalletConfig {
  primaryCurrency: {
    base: string;
    spendable: string;
  };
  secondaryCurrencies: string[];
}

export interface IOnboardingConfig {
  hidden?: boolean;
}

export interface IThemeConfig {
  name: string;
  colors?: IPalette;
  legalDocuments?: ILegalDocuments;
  pages: IPagesConfig;
  wallet: IWalletConfig;
  theme: IThemeEnum;
  onboarding?: IOnboardingConfig;
}

export type IFullTheme = IThemeConfig & ITheme;

export interface IThemeResponsiveImages {
  '1x': string; '2x': string; '3x': string;
}
export interface IThemeImages {
  achievementHeader: string;
  headerLogo: string;
  notchLogo: string;
  notchBadgeLogo: string;
  pwaCover?: string;
  rankHeader: string;
  checkIcon: IThemeResponsiveImages;
  loadingLogo: IThemeResponsiveImages;
  rankBG: IThemeResponsiveImages;
}
